import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "reactstrap";
import { AppContext } from "components/AppContext";
import "styles/Public.scss";
import LoginImg from "../Images/hStream_signin_img.png";
import hstreamLogo from "../Images/hStream_Logo_blue.png";
import DataExtractLogo from "../Images/DataExtractLogo";

const PublicWrapper = () => {
  const { signIn, authInProgress } = useContext(AppContext);

  return (
    <div className="landingPage">
      {authInProgress && <div className="overlay" />}
      <section className="landingPage__body">
        <div>
          <div>
            <h1>Welcome to Insights</h1>
            <h2>Sign in with your hStream ID to access Insights.</h2>
            <button
              type="button"
              id="publicWrapperHstreamAuth"
              onClick={signIn}
            >
              <img src={hstreamLogo} alt="hstream branding logo" />
              Sign in with hStream
            </button>
          </div>
          <img src={LoginImg} alt=" " className="loginImg" />
        </div>
      </section>
    </div>
  );
};

export default PublicWrapper;
